import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getSellUsers } from '@/api/user';
var DEFAULT_FORM = {
  customer_type: '',
  discount: '',
  service_cost: '',
  settlement_type: '',
  company_cost: '',
  diff_money: '',
  diff_remark: '',
  commission_type: '',
  the_loser_id: '',
  target_cost_rate: ''
};
export default {
  name: 'DeliveryInfoForm',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    editable: {
      type: Boolean,
      default: true
    },
    showConfirm: {
      type: Boolean,
      default: false
    },
    confirmLoading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      form: _objectSpread({}, DEFAULT_FORM),
      sellUserList: [] // 交付负责人候选列表
    };
  },
  computed: {
    rules: function rules() {
      var moneyRule = {
        pattern: /^\d{1,9}(\.\d{1,2})?$/,
        message: '只能输入大于等于0的数字，最多两位小数',
        trigger: 'blur'
      };
      return {
        discount: [{
          required: true,
          message: '请输入折扣',
          trigger: 'blur'
        }, {
          pattern: /^\d{1,9}(\.\d{1,3})?$/,
          message: '请填写 0 -1 范围之间，支持三位小数',
          trigger: 'blur'
        }],
        service_cost: [moneyRule],
        company_cost: [moneyRule],
        diff_money: [{
          required: true,
          message: '请填写偏差金额',
          trigger: 'blur'
        }, {
          // 与新建订单页口径一致，允许正负号
          pattern: /^[- | +]?\d{1,9}(\.\d{1,2})?$/,
          message: '请填写偏差金额，仅限小数点后两位',
          trigger: 'blur'
        }],
        diff_remark: [{
          required: this.form.diff_money != 0,
          message: '请填写偏差原因',
          trigger: 'blur'
        }],
        commission_type: [{
          required: true,
          message: '请选择佣金核算方式',
          trigger: 'change'
        }],
        settlement_type: [{
          required: true,
          message: '请选择结算方式',
          trigger: 'change'
        }],
        target_cost_rate: [{
          required: true,
          message: '请输入成本率目标',
          trigger: 'blur'
        }, {
          pattern: /^\d+(\.\d{1,2})?$/,
          message: '请输入有效的数值，最多两位小数',
          trigger: 'blur'
        }]
      };
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function handler(val) {
        if (JSON.stringify(val || {}) !== JSON.stringify(this.form)) {
          this.form = _objectSpread(_objectSpread({}, DEFAULT_FORM), val);
        }
      }
    },
    form: {
      deep: true,
      handler: function handler(val) {
        this.$emit('input', _objectSpread({}, val));
      }
    }
  },
  created: function created() {
    this.getSellUsersList();
  },
  methods: {
    // 获取交付负责人候选列表
    getSellUsersList: function getSellUsersList() {
      var _this = this;
      getSellUsers({
        type: 3
      }).then(function (res) {
        _this.sellUserList = (res.data.list || []).filter(function (item) {
          return Number(item.status) === 10;
        });
      });
    },
    // 选择交付负责人后带出成本率目标
    onLeaderChange: function onLeaderChange(id) {
      var target = this.sellUserList.find(function (item) {
        return item.id === id;
      });
      this.form.target_cost_rate = target && target.target_cost_rate ? target.target_cost_rate : '';
    },
    // 表单校验，供父组件调用
    validate: function validate() {
      return this.$refs.deliveryForm.validate();
    },
    handleConfirm: function handleConfirm() {
      var _this2 = this;
      this.$refs.deliveryForm.validate(function (valid) {
        if (valid) {
          _this2.$emit('confirm', _objectSpread({}, _this2.form));
        }
      });
    }
  }
};